<template>
	<div class="home">
		<Encabezado></Encabezado>
		<div id="content" class="snap-content bg-home">
			<div class="container">
				<div class="header-clear"></div>
				<div id="itemList">
					<div class="itemList-controls">
						<div class="controls controls-left">
                            <router-link class="btn GeneralLeave-back btnBack" to="/vacaciones">
							    <font-awesome-icon icon="fa-solid fa-circle-chevron-left" /> Atrás
							</router-link>
                        </div>
						<div class="title">
							<h3>Vacaciones</h3>
						</div>
					</div>
                    <div class="itemList-header">
                        <h1>Nueva solicitud de vacaciones</h1>
                    </div>
                    <div class="item-Form">
                        <div class="panel-body">
                            <form 
                                class="form-horizontal" 
                                id="formNuevasVacaciones"
                                @submit.prevent="enviarDatosFormulario"
                            >
                                <div class="form-group">
                                    <div class="col-md-6 col-xs-12">
                                        <label for="fechaDesde">Fecha Desde</label>
                                        <br />
                                        <date-picker 
                                            class="dateTimePicker"
                                            v-model="fechaDesde"    
                                            value-type="format"
                                            :editable="false"
                                            :formatter="momentFormat"
                                            :clearable = "false"
                                        ></date-picker>
                                    </div>
                                    <div class="col-md-6 col-xs-12">
                                        <label for="fechaHasta">Fecha Hasta</label>
                                        <br />
                                        <date-picker
                                            class="dateTimePicker"
                                            v-model="fechaHasta" 
                                            value-type="format"
                                            :editable="false"
                                            :formatter="momentFormat"
                                            :clearable = "false"
                                        ></date-picker>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="col-md-6 col-xs-12">
                                        <label for="numDias">Total Días</label>
                                        <input class="form-control" id="numDias" name="numDias" readonly="readonly" type="text" :value="numDias">
                                    </div>
                                </div>
                                
                                <hr />

                                <div class="form-group">
                                    <div class="col-md-12">
                                        <label for="observaciones">Observaciones</label>
                                        <textarea class="form-control" cols="20" id="observaciones" name="observaciones" v-model="observaciones" rows="5"></textarea>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="col-md-12"></div>
                                </div>
                                <div class="form-group">
                                    <div class="col-md-12">
                                        <div v-if="superaMaximoDias && !enviandoDatosFormulario" class="text-danger">
                                            Aviso.- El total de días no puede superar los días de vacaciones pendientes (<strong>{{ maximoDias }} día/s</strong>)
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="col-md-12">
                                        <input :disabled="!datosValidos || enviandoDatosFormulario" type="submit" class="btn btn-lg btn-primary" id="btnSave" :value="textoBtnEnvio">
                                    </div>
                                </div>
                            </form>    
                        </div>
                    </div>
                </div>
            </div>
            <br />
            <br />
            <br />
            <br />
            <br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<Footer></Footer>
		</div>
	</div>
</template>

<script>
// @ is an alias to /src
import Encabezado from "@/components/Encabezado.vue";
import Footer from "@/components/Footer.vue";
import router from "@/router";
import moment from "moment";

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';


export default {
    name: "NuevasVacaciones",
    components: {
        Encabezado,
        Footer,
        DatePicker
    },
    data() { 
        return{
            fechaDesde: moment(new Date()).format('L'),
            fechaHasta: moment(new Date()).format('L'),
            observaciones: null,
            quedanDiasAnioAnterior: false,
            momentFormat: {
                //[optional] Date to String
                stringify: (date) => {
                    return date ? moment(date).format('L') : ''
                },
                //[optional]  String to Date
                parse: (value) => {
                    return value ? moment(value, 'L').toDate() : null
                },
                //[optional] getWeekNumber
                getWeek: (date) => {
                    return // a number
                }
            }
        }
    },
    mounted() {
        this.$store.commit('establecerEstadoEnviandoDatosFormulario', false);
        this.$store.commit('establecerGuardadoOK', false);

        document.body.classList.remove("bg-login");
        document.body.classList.remove("login-page");
    },
    watch:{
        fechaDesde: function(){
            if (this.numDias<1){
                this.fechaHasta = this.fechaDesde;
            }
        },
        fechaHasta: function(){
            if (this.numDias<1){
                this.fechaHasta = this.fechaDesde;
            }
        },
        guardadoOK: function(newValue){
            if (newValue){
                this.$toast.open({
                    message: "Los datos se han guardado correctamente",
                    type: "success",
                    duration: 500,
                    dismissible: false,
                    position: "top",
                    onDismiss: this.redireccionListaVacaciones
                });
            }
        }
    },
    computed:{
        guardadoOK: function(){
            return this.$store.state.guardadoOK;
        },
        numDias: function(){
            let desde = moment(this.fechaDesde, 'L');
            let hasta = moment(this.fechaHasta, 'L');

            let dias = hasta.diff(desde, 'days');
            
            return dias + 1;
        },
        maximoDias: function(){
            let maximoDias = 0;
            let resumenVacaciones;

            if (!!this.$store.state.perfil.vacaciones){
                resumenVacaciones = this.$store.state.perfil.vacaciones.resumen || [];
                resumenVacaciones = ((Array.isArray(resumenVacaciones))? resumenVacaciones : [resumenVacaciones]);
                //resumenVacaciones = resumenVacaciones.filter((r) => !!(r.activo * 1));
        
                maximoDias = (resumenVacaciones[0].diasPendientes * 1) + ((resumenVacaciones[1]?.diasPendientes || 0) * 1);
            }
            return maximoDias;
        },
        superaMaximoDias: function(){
            return this.numDias > this.maximoDias;
        },
        datosValidos: function(){
            return (!this.superaMaximoDias);
        },
        textoBtnEnvio: function() {
            if (this.enviandoDatosFormulario) return 'Enviando...';
            if (this.datosValidos) return 'Enviar';
            if (!this.datosValidos) return 'Revise Avisos';  
        },
        enviandoDatosFormulario: function(){
            return this.$store.state.enviandoDatosFormulario; 
        }
    },
    methods:{
        enviarDatosFormulario: function(){
            this.$store.dispatch('enviarDatosNuevasVacaciones', 
                {
                    fechaDesde: this.fechaDesde,
                    fechaHasta: this.fechaHasta,
                    observaciones: this.observaciones
                }
            );
        },
        redireccionListaVacaciones: function(){
            router.replace('/vacaciones');
            this.$store.commit('establecerGuardadoOK', false);
        }
    }
};
</script>

<style scoped>
    @import "../assets/styles/home.css";
</style>
